import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
if (history.location && history.location.state && history.location.state.status) {
  const state = { ...history.location.state };
  delete state.status;
  history.replace({ ...history.location, state });
}
export default history;
